import { Button, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { UploadIcon } from '@/imports/ui/chakra/customIcon/UploadIcon';

import { OrganizationsCsvArchiveModal } from '../OrganizationsCsvArchiveModal';

export const BulkArchiveOrganizationsCsvButton: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        variant="outline"
        colorScheme="red"
        borderColor="red.500"
        onClick={onOpen}
      >
        <UploadIcon mr="2" height="24px" width="28px" mt="-5px" />
        Bulk Archive
      </Button>
      <OrganizationsCsvArchiveModal open={isOpen} onClose={onClose} />
    </>
  );
};
